import React,{useEffect,useState} from 'react'
import {Navbar,Nav,Button } from 'react-bootstrap'
import {NavLink,Link, useNavigate} from 'react-router-dom';
import '../../sassFiles/mobile/sassPages/homepage.scss'
import { Accordion,Card } from 'react-bootstrap';
import {Row,Col} from 'react-bootstrap'
import { adminSidebarApi } from '../../utils/AdminDashApi/AdminSidebar';
const AdminDashSidebarSidebarComp = () => {
    let navigate = useNavigate()
   
  let activeStyle = {
    color:"#ED1C24"
  };
const [varforiconchange,setvarforiconchange ]=useState("")
const handleonclick=()=>{
  
  
  var mynavbarnav = document.getElementById("mynavbarnav");
  mynavbarnav.classList.toggle('show');
  mynavbarnav.classList.toggle('navbar-white');
}


const handletoggler=()=>{
  var navtoggler = document.getElementById("nav-icon4");
  navtoggler.classList.toggle('open');
  

}
const [activeKey, setActiveKey] = useState('');
const handleAccordionToggle = (eventKey) => {
    setActiveKey(activeKey === eventKey ? '' : eventKey);
  };

const handleTabvalue=(mytabval)=>{
    var mynavbarnav = document.getElementById("mynavbarnav");
    mynavbarnav.classList.remove('show');
    var navtoggler = document.getElementById("nav-icon4");
    navtoggler.classList.toggle('open');
    
    var getiddashboardtab = document.getElementById("dashboardTab")
    var getiddocumenttab = document.getElementById("documentTab")
    var getinoticetab = document.getElementById("noticeTab")
    var getclassroutinetab = document.getElementById("classRoutineTab")
    var getatttab = document.getElementById("attendanceTab")
    var getbillinfotab = document.getElementById("billInfoTab")
    var getresulttab = document.getElementById("resultTab")
    var getprofiletab = document.getElementById("profileTab")
    var getexamroutinetab = document.getElementById("examRoutineTab")

    getiddashboardtab.classList.remove("activei")
    getiddocumenttab.classList.remove("activei")
    getinoticetab.classList.remove("activei")
    getatttab.classList.remove("activei")
    getclassroutinetab.classList.remove("activei")
    getbillinfotab.classList.remove("activei")
    getresulttab.classList.remove("activei")
    getprofiletab.classList.remove("activei")
    getexamroutinetab.classList.remove("activei")

    var getidtab = document.getElementById(mytabval)
    setvarforiconchange(mytabval)
    getidtab.classList.add('activei')

}
const handlelogout=()=>{
    navigate("/")
}
const handleLi = (mylink)=>{
    navigate(mylink)
   
  }
  
  return (
    <>
          <Navbar id="navbarmini" className="mynavbarmb studashnav mynavbarnav admindashsidebar" expand="lg">
            
            <div className="headerwrapper">
              <Row style={{width:"100%"}}>
                <Col xs={2}>
                    <div className='navbar-brand2'>
                      <Link to="/"><img src="./assets/images/logo/navbar_logo.png" alt="logo" /> </Link>
                                         
                </div>                
                </Col>
                <Col xs={9} style={{paddingRight:"0",paddingLeft:"0"}} className="togglermenuclass2">
                    <p>British Standard School</p> 
                </Col>

                <Col xs={1} className="togglermenuclass">
                <div className="navbar-toggler" onClick={handleonclick} id="navbar-toggler" aria-controls="basic-navbar-nav" >
                <div id="nav-icon4" onClick={handletoggler}>
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
                </div>
                </Col>
              </Row>
                
             <div className="menuItem">
             <Nav className="mynavbarnav adminnavmb" id="mynavbarnav">
             <div className="scrollable">
                {
                  adminSidebarApi.menuItem.map((item,index)=>{
                    if(item.drpdwn.length!==0){
                      return(
                        <Accordion key={index} activeKey={activeKey} onSelect={handleAccordionToggle}>
                        <Accordion.Item  eventKey={index}>
                          <Accordion.Header>
                            <img src={item.img} alt="" /> <span>{item.name}</span> 
                          
                            </Accordion.Header>
                          <Accordion.Body>
                          <ul>
                          { item.drpdwn.map((item2,key2)=>{
                            return(
                              <li key={key2} onClick={()=>handleLi(item2.link)}> 
                              <div className={window.location.pathname==item2.link?`wr active`:`wr`}>
                                {item2.item}
                                </div>
                                 </li>
                            )
                          })}

                        </ul>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                      )

                    }else{
                      return(
                        <Card key={index} className={window.location.pathname==item.link?"item active":"item"}><Link to={item.link}> {window.location.pathname==item.link? <img src={item.activeicon} alt="" />:<img src={item.img} alt="" /> } <span>{item.name}</span></Link></Card>
                      )
                    }
                    
                  })
                }
                </div>
                </Nav>
             </div>
                
               
                
                
            
            </div>
            </Navbar>
    </>
  )
}

export default AdminDashSidebarSidebarComp